var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "transition",
    d: "M9.49993 3.25839C10.24 2.76392 11.11 2.5 12 2.5C13.1935 2.5 14.3381 2.97411 15.182 3.81802C16.0259 4.66193 16.5 5.80653 16.5 7C16.5 7.89002 16.2361 8.76005 15.7416 9.50007C15.2471 10.2401 14.5443 10.8169 13.7221 11.1575C12.8998 11.4981 11.995 11.5872 11.1221 11.4135C10.2492 11.2399 9.44736 10.8113 8.81802 10.182C8.18868 9.55264 7.7601 8.75082 7.58647 7.87791C7.41283 7.00499 7.50195 6.10019 7.84254 5.27792C8.18314 4.45566 8.75991 3.75285 9.49993 3.25839ZM10.0555 9.91014C10.6311 10.2947 11.3078 10.5 12 10.5C12.9283 10.5 13.8185 10.1313 14.4749 9.47487C15.1313 8.8185 15.5 7.92826 15.5 7C15.5 6.30777 15.2947 5.63108 14.9101 5.0555C14.5256 4.47993 13.9789 4.03133 13.3394 3.76642C12.6999 3.50152 11.9961 3.4322 11.3172 3.56725C10.6383 3.7023 10.0146 4.03564 9.52513 4.52513C9.03564 5.01461 8.7023 5.63825 8.56725 6.31718C8.4322 6.99612 8.50151 7.69985 8.76642 8.33939C9.03133 8.97893 9.47993 9.52556 10.0555 9.91014ZM20.5 20V20.5H19.5V20C19.5 18.5413 18.9205 17.1424 17.8891 16.1109C16.8576 15.0795 15.4587 14.5 14 14.5H10C8.54131 14.5 7.14236 15.0795 6.11091 16.1109C5.07946 17.1424 4.5 18.5413 4.5 20V20.5H3.5V20C3.5 18.2761 4.18482 16.6228 5.40381 15.4038C6.62279 14.1848 8.27609 13.5 10 13.5H14C15.7239 13.5 17.3772 14.1848 18.5962 15.4038C19.8152 16.6228 20.5 18.2761 20.5 20Z",
    fill: "white",
    stroke: "#070038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthInactive);
export default __webpack_public_path__ + "static/media/auth-inactive.6905bdc2be719b5cfe7111c6ef9d125a.svg";
export { ForwardRef as ReactComponent };